"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButtons = void 0;
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _defaultTranslations = require("../../constants/defaultTranslations");
var _TranslationKey = require("../../models/TranslationKey");
var _ActionButtonStyled = require("./ActionButtonStyled");
var _jsxRuntime = require("react/jsx-runtime");
const ActionButtons = props => {
  const {
    isValid,
    isDirty,
    isTouchedForm,
    isSubmitting,
    isDisabled,
    isEveryInvalidFieldTouched = true,
    dataTestIdPrefix = '',
    handleCancel,
    handleSave,
    showCancelButton
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const allowSaveButton = isDirty && !isEveryInvalidFieldTouched || isDirty && isValid;
  const saveButtonType = handleSave ? 'button' : 'submit';
  const saveButtonColor = allowSaveButton ? 'primary' : 'inherit';
  const saveButtonDisabled = (allowSaveButton ? isSubmitting : true) || (isDisabled ?? false);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ActionButtonStyled.RootContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      maxWidth: "330px",
      width: "100%",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionButtonStyled.ButtonSave, {
        fullWidth: true,
        type: saveButtonType,
        color: saveButtonColor,
        variant: "contained",
        disabled: saveButtonDisabled,
        "data-testid": getTestId(`${dataTestIdPrefix}SaveButton`),
        ownerState: {
          disabled: saveButtonDisabled
        },
        onClick: handleSave ?? undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
          id: _TranslationKey.TranslationKey.save,
          defaultMessage: _defaultTranslations.defaultTranslations.save
        })
      })
    }), isTouchedForm && showCancelButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      maxWidth: "330px",
      width: "100%",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionButtonStyled.ButtonCancel, {
        variant: "text",
        "data-testid": getTestId(`${dataTestIdPrefix}CancelButton`),
        onClick: handleCancel,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
          id: _TranslationKey.TranslationKey.cancel,
          defaultMessage: _defaultTranslations.defaultTranslations.cancel
        })
      })
    }) : null]
  });
};
exports.ActionButtons = ActionButtons;
//# sourceMappingURL=ActionButton.js.map